import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthorizationService } from '../../services/authorization/authorization.service';
import { UserService } from '../../services/authorization/user.service';

export const authorizationGuard: CanActivateFn = () => {
  const userService: UserService = inject(UserService);
  const authorizationService: AuthorizationService =
    inject(AuthorizationService);
  const router: Router = inject(Router);

  if (!authorizationService.isLoggedIn) {
    router.navigate(['/authorization']);
    return false;
  }

  if (userService.user && !userService.user?.domain) {
    router.navigate(['/authorization/register-workspace']);
    return false;
  }

  return true;
};
